import { connector } from "../../utils/common/connector";

const controller = "campaignList";

// ---------------------------------------------
// CREATE CAMPAIGN LIST
// ---------------------------------------------
export const createCampaignListService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.post(
      controller,
      "createCampaignList",
      params,
    );

    reply = {
      campaignList: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      campaignList: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// UPDATE CAMPAIGN LIST
// ---------------------------------------------
export const updateCampaignListService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.post(
      controller,
      "updateCampaignList",
      params,
    );

    reply = {
      campaignList: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      campaignList: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CAMPAIGN LIST (PAGINATED)
// ---------------------------------------------
export const getCampaignListService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.get(controller, "getCampaignList", params);

    reply = {
      campaignLists: response?.campaignLists ?? [],
      totalCampaignList: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      campaignLists: [],
      totalCampaignList: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CAMPAIGN LIST BY ID
// ---------------------------------------------
export const getCampaignListByIdService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.get(controller, "byId", params);

    reply = {
      campaignList: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      campaignList: {},
    };
  }

  return reply;
};
